export const GHOST_COIN_URL = 'https://public.ghst.io/ghost-coin-v1.webp';
